import gainsight from './gainsight';

// eslint-disable-next-line import/prefer-default-export
export { gainsight };
